import DefaultLayout from "./Default/content";
import Empty from "./Empty";

export const EmptyLayout = Empty;
export default DefaultLayout;
